const ErrorFallback = ({ error, resetError }) => {
  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '2rem',
        textAlign: 'center',
        fontFamily: 'inherit'
      }}
    >
      <h1 style={{ fontSize: '1.75rem', marginBottom: '0.75rem', color: '#b30000' }}>
        Something went wrong
      </h1>
      <p style={{ maxWidth: '28rem', marginBottom: '1.5rem', color: '#555' }}>
        An unexpected error occurred. Our team has been notified. Please try again or return home.
      </p>
      {process.env.NODE_ENV === 'development' && error?.message && (
        <pre
          style={{
            maxWidth: '100%',
            overflow: 'auto',
            padding: '1rem',
            marginBottom: '1.5rem',
            background: '#f5f5f5',
            borderRadius: '4px',
            fontSize: '0.75rem',
            textAlign: 'left'
          }}
        >
          {error.message}
        </pre>
      )}
      <div style={{ display: 'flex', gap: '0.75rem', flexWrap: 'wrap', justifyContent: 'center' }}>
        {typeof resetError === 'function' && (
          <button type="button" className="btn btn-primary" onClick={resetError}>
            Try again
          </button>
        )}
        <a href="/" className="btn btn-outline-secondary">
          Go to home
        </a>
      </div>
    </div>
  )
}

export default ErrorFallback
